const icons = {
  PRODUCTION_CENTER: require('./02.png'),
  DOCUMENT_CENTER: require('./03.png'),
  EQUIPMENT_MANAGE: require('./05.png'),
  INSPECT_CENTER: require('./04.png'),
}
export default icons